import { gql } from 'urql';

export const UnassignedBaaAccountFragment = gql`
  fragment UnassignedBaaAccountFragment on UnassignedBaaAccount {
    __typename
    id
    name
    value
    accountType
    updatedAt
    status
    firmMemberID
    statusErrorCode
    accountNumber
    BAAFinancialProfileID
    financialInstitutionID
    financialInstitutionName
  }
`;
